export default "__VITE_ASSET__e4af2583__"